import { ApplicationDataState } from './application.model';
import { SocietyCode } from '../stepper/stepper.model';

export const initialValue: ApplicationDataState = {
  pointOfSale: {
    unionCode: '7009316993',
    groupCode: '7009211608',
    societyCode: SocietyCode.CETELEM,
    chainCode: ''
  }
};
